// ミリ秒を「mm:ss」「hh:mm:ss」「N日 hh:mm:ss」の形式に整形する。
export const formatDurationJa = (ms: number) => {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const sec = totalSec % 60;
  const totalMin = Math.floor(totalSec / 60);
  const min = totalMin % 60;
  const totalHour = Math.floor(totalMin / 60);
  const hour = totalHour % 24;
  const day = Math.floor(totalHour / 24);

  const hh = String(hour).padStart(2, "0");
  const mm = String(min).padStart(2, "0");
  const ss = String(sec).padStart(2, "0");

  if (day > 0) return `${day}日 ${hh}:${mm}:${ss}`;
  if (totalHour > 0) return `${hh}:${mm}:${ss}`;
  return `${String(totalMin).padStart(2, "0")}:${ss}`;
};
